import { changeRoundStateAction } from 'core/widgets/RoundStates/actions';
import { put, select } from 'redux-saga/effects';
import { Notifications } from 'types';

import { resetRepeatBetAction, saveRoundBetAction } from 'core/widgets/BetRepeat/actions';
import { resetDoubleBetAction } from 'core/widgets/BetDouble/actions';
import { setTotalBetAction } from 'core/widgets/User/actions';
import { RoundStates } from '../../RoundStates/types';
import { saveWinnerToStoreAction, clearAllBetsAction } from 'core/widgets/RouletteBet/actions';
import { confirmedBetsSelector } from 'core/widgets/RouletteBet/selectors';
import { IClientBet } from 'widgets/Roulette/types';
import { addNewRoundToStatistics } from 'core/widgets/LastWinners/actions';

export function* onResultConfirmedSaga({ type: notificationType, data: result }: any) {
  if (notificationType === Notifications.RESULT_CONFIRMED) {
    const { winner } = result;
    const confirmedBets: IClientBet[] = yield select(confirmedBetsSelector);

    yield put(setTotalBetAction(0));

    yield put(resetDoubleBetAction());
    yield put(resetRepeatBetAction());

    yield put(saveWinnerToStoreAction({ winner: winner.toString() }));
    yield put(addNewRoundToStatistics(winner.toString()));
    yield put(changeRoundStateAction({ roundState: RoundStates.ResultConfirmed }));

    yield put(saveRoundBetAction(confirmedBets));

    yield put(clearAllBetsAction());
  }
}
